/**
 * System-generated list tags (computed backend-side from catalog data, not
 * from rules). Hidden on drop rows to keep the Leads column compact — the
 * tag FILTER still offers them (it reads the raw resolver output).
 * For Media Devoted | Created By Ciro Autiero
 */

export const SYSTEM_LIST_TAGS: ReadonlySet<string> = new Set(['New', 'Unused']);
